import React from "react";
import { cn } from "../../../common/u1/cn";
import { Button } from "../../../common/u1/Button";
import { DocumentIcon } from "../../../../assets/ui/icons";

/* Nothing bought yet. Transcribed from the live screen's empty branch: the same message and the same single call to action, which goes wherever the caller's... */
export const BillingEmptyState = ({ onStart, className = "" }) => (
  <section
    className={cn(
      "rounded-[18px] border border-[var(--line)] bg-white p-10 text-center",
      "shadow-[0_1px_2px_rgba(20,40,60,.03)]",
      className
    )}
  >
    <span
      aria-hidden="true"
      className={cn(
        "mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full",
        "bg-[var(--coral-soft)] text-[var(--coral)]"
      )}
    >
      <DocumentIcon size={26} />
    </span>

    <h3 className="m-0 text-[17px] font-bold text-[var(--ink)] font-sans">
      No payments yet
    </h3>
    <p className="mx-auto mt-1.5 mb-5 max-w-[360px] text-[13.5px] leading-[1.5] text-[var(--muted)] font-sans">
      All your billing will appear here once you buy a plan or a Web Profile.
    </p>

    <Button variant="coral" onClick={onStart}>
      Start purchasing
    </Button>
  </section>
);

export default BillingEmptyState;
